/* sns-article.js
Powers article styling + “copy” buttons created from simple tokens in text:
[copy-page-url] → copies current page URL
[copy:Hello%20there] → copies arbitrary text (URL-encoded)
[copy:step2] → copies a predefined snippet (see map)
*/

// 1) Scope article CSS with a body class
document.addEventListener('DOMContentLoaded', () => {
document.body.classList.add('sns-article');
});

// 2) Predefined snippets you want readers to copy (for Step 2)
const SNS_SNIPPETS = {
step2:
`<script id="sns-article-boot">
document.addEventListener('DOMContentLoaded',()=>{document.body.classList.add('sns-article')});
</script>
<script src="{{ 'sns-article.js' | asset_url }}"></script>`
};

// 3) Turn token text nodes into real buttons
(function injectCopyButtonsSetup(){
function inject(root = document.body){
const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
const toReplace = [];
while (walker.nextNode()) {
const n = walker.currentNode;
const v = n.nodeValue || '';
if (v.includes('[copy-page-url]') || /\[copy:[^\]]+\]/i.test(v)) toReplace.push(n);
}

toReplace.forEach(n => {
let text = n.nodeValue;

// Mark tokens
text = text.replace(/\[copy-page-url\]/gi, '<<<COPYBTN::page-url>>>');
text = text.replace(/\[copy:([^\]]+)\]/gi, (_, p1) => `<<<COPYBTN::${p1}>>>`);

const frag = document.createDocumentFragment();
text.split(/(<<<COPYBTN::[^>]+>>>)/).forEach(part => {
const m = /^<<<COPYBTN::(.+)>>>$/.exec(part);
if (!m) {
if (part) frag.appendChild(document.createTextNode(part));
} else {
const payload = m[1];
const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'button sns-copy-btn';
btn.dataset.payload = payload; // "page-url" | "step2" | encoded text
btn.setAttribute('aria-live', 'polite');
btn.textContent = (payload === 'page-url') ? 'Copy link' :
(SNS_SNIPPETS[payload] ? 'Copy code' : 'Copy');
frag.appendChild(btn);
}
});

n.parentNode.replaceChild(frag, n);
});
}

// Initial inject + watch for dynamic DOM changes (accordions opening, etc.)
inject();
const mo = new MutationObserver(muts => {
for (const m of muts) {
m.addedNodes && m.addedNodes.forEach(node => {
if (node.nodeType === 1) inject(node);
});
}
});
mo.observe(document.body, { childList: true, subtree: true });

// Delegated click handler: write to clipboard + toast
document.addEventListener('click', async e => {
const btn = e.target.closest('.sns-copy-btn');
if (!btn) return;

e.preventDefault();

const payload = btn.dataset.payload || 'page-url';
const text =
payload === 'page-url' ? window.location.href
: (SNS_SNIPPETS[payload] ?? decodeURIComponent(payload));

const ok = await (async t => {
try { await navigator.clipboard.writeText(t); return true; }
catch {
// Fallback for strict browsers
try {
const ta = document.createElement('textarea');
ta.value = t; ta.style.position='fixed'; ta.style.opacity='0';
document.body.appendChild(ta); ta.select();
const good = document.execCommand('copy'); ta.remove();
return good;
} catch { return false; }
}
})(text);

const old = btn.textContent;
btn.textContent = ok ? 'Copied!' : 'Copied*';
btn.disabled = true;
btn.classList.add('sns-copied');
toast(ok ? 'Copied!' : 'Copied (limited mode)');

setTimeout(() => {
btn.textContent = old;
btn.disabled = false;
btn.classList.remove('sns-copied');
}, 1200);
});

function toast(msg){
let t = document.querySelector('#sns-toast');
if (!t) {
t = document.createElement('div');
t.id = 'sns-toast';
document.body.appendChild(t);
}
t.textContent = msg;
t.classList.add('show');
setTimeout(()=> t.classList.remove('show'), 1200);
}
})();